import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'
import http from 'API/http'
import { notify, MetricsHelper } from 'helpers'

class CPEstatus extends Component {
  constructor (props) {
    super(props)
    this.state = {
      cpeStatus: null,
      error: false,
      loading: true
    }
  }
  async componentDidMount () {
    this.setState({loading: true})
    await this.getCPEstaus(this.props.cpeStatus, this.props.errors)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true})
    this.getCPEstaus(props.cpeStatus, props.errors)
  }
  async getCPEstaus (cpeStatus, err) {
    if (!cpeStatus && !err.error) return
    if (err.error) return this.setState({error: err, loading: false})
    this.setState({ cpeStatus: cpeStatus, loading: false })
  }
  reload () {
    this.setState({loading: true})
    this.props.reload()
  }
  portMetrics (ports) {
    if (!ports || ports.length === 0) return []
    var formatted = []
    ports.map(port => {
      formatted.push(Object.values(Object.assign({'name': port.name, 'type': 'Input'}, MetricsHelper.port(port.statistics.input))))
      formatted.push(Object.values(Object.assign({'name': port.name, 'type': 'Output'}, MetricsHelper.port(port.statistics.output))))
    })
    return formatted
  }
  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='CPE Status' icon='shield' buttons={[{ icon: 'fa-refresh', event: () => this.reload() }]}>
        <div className='row'>
          <div className='col-md-12'>
            <span className='label label-dark large-label'><b>CPE</b></span>
            {this.state.cpeStatus &&
              <div>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={[[
                    (this.state.cpeStatus.up ? <span className='label orders-label label-success'>UP</span> : <span className='label orders-label label-danger'>DOWN</span>),
                    this.state.cpeStatus.firmware,
                    this.state.cpeStatus.vendor,
                    this.state.cpeStatus.model,
                    this.state.cpeStatus.mac,
                    this.state.cpeStatus.upSince
                  ]]}>
                    <tr>
                      <th>Up</th>
                      <th>Firmware</th>
                      <th>Vendor</th>
                      <th>Model</th>
                      <th>Mac</th>
                      <th>Up Since</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>CPE - Mac Address Table</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={this.state.cpeStatus.macAddressTable.map(mac => [
                    'Port ' + mac.port,
                    mac.mac,
                    mac.serviceType,
                  ])}>
                    <tr>
                      <th>Port</th>
                      <th>MAC</th>
                      <th>Service Type</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>CPE - DHCP-Snooping</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={this.state.cpeStatus.dhcpSnooping.map(snoop => [
                    snoop.ip,
                    snoop.mac,
                    snoop.serviceType,
                    snoop.timeout,
                  ])}>
                    <tr>
                      <th>IP</th>
                      <th>MAC</th>
                      <th>Service Type</th>
                      <th>Timeout</th>
                    </tr>
                  </FlowTable>
                </pre>
                  <span className='label label-dark large-label'><b>CPE - Ports</b></span>
                  <pre className='no-overflow mt-10 no-padding'>
                    <FlowTable noClass data={this.state.cpeStatus.ports.map(port => [
                      port.name,
                      (port.link ? <span className='label orders-label label-success'>UP</span> : <span className='label orders-label label-danger'>DOWN</span>),
                      port.ifDescription,
                      (port.fullDuplex ? <span className='label orders-label label-success'>YES</span> : <span className='label orders-label label-danger'>NO</span>),
                      port.changedAt,
                      port.loopDetectionStatus,
                      (port.freeSeating ? <span className='label orders-label label-success'>YES</span> : <span className='label orders-label label-danger'>NO</span>),
                      port.configuredSpeed,
                      port.linkSpeed,
                    ])}>
                      <tr>
                        <th>Name</th>
                        <th>Link</th>
                        <th>Description</th>
                        <th>Full Duplex</th>
                        <th>Changed</th>
                        <th>Loop Detection Status</th>
                        <th>Freeseating</th>
                        <th>Configured-Speed</th>
                        <th>Link-Speed</th>
                      </tr>
                    </FlowTable>
                  </pre>
                  <span className='label label-dark large-label'><b>CPE - Ports - Fiber</b></span>
                  <pre className='no-overflow mt-10 no-padding'>
                    <FlowTable noClass data={this.state.cpeStatus.ports.map(port => [
                      port.name,
                      (port.fiber ? port.fiber.dbmRx : '-'),
                      (port.fiber ? port.fiber.dbmTx : '-'),
                      (port.fiber ? port.fiber.temp : '-'),
                    ])}>
                      <tr>
                        <th>Port</th>
                        <th>dbmRx</th>
                        <th>dbmTx</th>
                        <th>Temp</th>
                      </tr>
                    </FlowTable>
                  </pre>
                  <span className='label label-dark large-label'><b>CPE - Ports - Metrics</b></span>
                  <pre className='no-overflow mt-10 no-padding'>
                    <FlowTable noClass data={this.portMetrics(this.state.cpeStatus.ports)}>
                      <tr>
                        <th>Port</th>
                        <th>Type</th>
                        <th>Errors</th>
                        <th>CRC-Errors</th>
                        <th>Bytes</th>
                        <th>Multicast</th>
                        <th>Unicast</th>
                      </tr>
                    </FlowTable>
                </pre>
              </div>
            }
            {this.state.error &&
              <pre className='no-overflow mt-10 no-padding'>
                <div className='error-wrapper'>
                  <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching CPE Status {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
                </div>
              </pre>
            }
          </div>
        </div>
      </StaticBox>
    )
  }
}
export default CPEstatus



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/troubleshooting/CPEstatus.js